// latest date first
export const sortByDateDesc = (o1, o2) => o1.date > o2.date ? -1 : 1;



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/utils/sorting.ts